export const CustomerData = [
  {
    id: 1,
    CustomerName: "EBS",
    CustomerType: "SUARL",
    TaxNumber: "15064KM/000",
    Fax: "",
    Email: "contact@ebs.com",
    Phone: "+21673465222",
    Adresse: "Imm. les jardins",
    PostalCode : "5000",
    Town : "Monastir",
    Country: "Tunisie",
    ContactName : "Montassar KLILA KERKENI",
    ContactPhone : "+216 22 947 145",
    ContactEmail : "monta@ebs.com",
    ContactRole : "CEO",
    Active : true,
    IsEmployee : false,
    Contract : true,
    ContractEnd : "31 Oct 2025",
    GlobalDiscount : 10,
    ContractDiscount : 15,
  },
  {
    id: 2,
    CustomerName: "Société XX",
    CustomerType: "SARL",
    TaxNumber: "15064KM/000",
    Fax: "",
    Email: "contact@xx.com",
    Phone: "+21673986332",
    Adresse: "Imm. xxxx",
    PostalCode : "4000",
    Town : "Sousse",
    Country: "Tunisie",
    ContactName : "Foulen ben ",
    ContactPhone : "+216 12 588 698",
    ContactEmail : "contact@ebs.com",
    ContactRole : "DAF",
    Active : true,
    IsEmployee : false,
    Contract : true,
    ContractEnd : "31 Dec 2025",
    GlobalDiscount : 0,
    ContractDiscount : 5,
  },
  {
    id: 3,
    CustomerName: "Hotel",
    CustomerType: "SARL",
    TaxNumber: "15064KM/000",
    Fax: "",
    Email: "contact@hotel.com",
    Phone: "+21671465222",
    Adresse: "Les berges du ",
    PostalCode : "1002",
    Town : "Tunis",
    Country: "Tunisie",
    ContactName : "Mohamed",
    ContactPhone : "+216 99 999 878",
    ContactEmail : "Mohamed@hotel.com",
    ContactRole : "Commerciale",
    Active : true,
    IsEmployee : false,
    Contract : false,
    ContractEnd : "",
    GlobalDiscount : 20,
    ContractDiscount : 0,
  },
  {
    id: 4,
    CustomerName: "Amine ben abdallah",
    CustomerType: "Sans statut",
    TaxNumber: "",
    Fax: "",
    Email: "amine@pp.com",
    Phone: "+21622955555",
    Adresse: "Km 2 rue Mahdia ",
    PostalCode : "7000",
    Town : "Sfax",
    Country: "Tunisie",
    ContactName : "Amine ben abdallah",
    ContactPhone : "+21622955555",
    ContactEmail : "amine@pp.com",
    ContactRole : "DG",
    Active : true,
    IsEmployee : false,
    Contract : true,
    ContractEnd : "12 Dec 2025",
    GlobalDiscount : 20,
    ContractDiscount : 25,
  },
  {
    id: 5,
    CustomerName: "Idriss d",
    CustomerType: "Personne phisique",
    TaxNumber: "xxxxxxxxxxx",
    Fax: "",
    Email: "Idriss@pp.com",
    Phone: "+21641252698",
    Adresse: "El Menzah 5",
    PostalCode : "1000",
    Town : "Tunis",
    Country: "Tunisie",
    ContactName : "Amira xxxxxx",
    ContactPhone : "+21641252698",
    ContactEmail : "amira@pp.com",
    ContactRole : "",
    Active : false,
    IsEmployee : false,
    Contract : false,
    ContractEnd : "",
    GlobalDiscount : 0,
    ContractDiscount : 12,
  },
  {
    id: 6,
    CustomerName: "Med Kabani",
    CustomerType: "Personne phisique",
    TaxNumber: "xxxxxxxxxxx",
    Fax: "",
    Email: "kabanimo@lesgalets.com",
    Phone: "+21698569587",
    Adresse: "La Marsa",
    PostalCode : "1000",
    Town : "Tunis",
    Country: "Tunisie",
    ContactName : "Med Kabani",
    ContactPhone : "+21698569587",
    ContactEmail : "kabanimo@lesgalets.com",
    ContactRole : "Directeur",
    Active : true,
    IsEmployee : true,
    Contract : false,
    ContractEnd : "",
    GlobalDiscount : 50,
    ContractDiscount : 0,
  },
  {
    id: 7,
    CustomerName: "Passager",
    CustomerType: "Sans statut",
    TaxNumber: "",
    Fax: "",
    Email: "",
    Phone: "",
    Adresse: "",
    PostalCode : "",
    Town : "",
    Country: "",
    ContactName : "",
    ContactPhone : "",
    ContactEmail : "",
    ContactRole : "",
    Active : true,
    IsEmployee : false,
    Contract : false,
    ContractEnd : "",
    GlobalDiscount : 0,
    ContractDiscount : 0,
  }
];
